import { makeStyles } from "@material-ui/core"

const styles = makeStyles((theme) => ({
  dialogContainer: {
    maxHeight: "500px",
    minWidth: "600px",
    [theme.breakpoints.down("sm")]: {
      maxHeight: "700px",
    },
  },
  dialogTop: {
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      alignItems: "flex-start",
    },
  },
  title: {
    marginTop: "8px",
    fontWeight: "bold",
    marginBottom: "8px",
    color: "#17A5b1",
  },
  dialogTitle: { marginTop: "8px", fontWeight: "bold", marginBottom: "8px" },

  searchIcon: {
    color: "#E2E2E2",
  },
  dialogContent: {
    display: "flex",
    justifyContent: "center",
    alignItems: "left",
    flexDirection: "column",
  },
  inputBoxes: {
    textAlign: "left",
    paddingLeft: "10px",
    height: "35px",
    width: "550px",
    fontSize: "inherit",
    backgroundColor: "#F4F4F4",
    '&[class*="MuiFilledInput-root"]': {
      paddingTop: 0,
    },
    borderRadius: "4px",
    border: "none",
    font: "inherit",
    fontStyle: "inherit",
    fontVariantLigatures: "inherit",
    fontVariantCaps: "inherit",
    fontVariantNumeric: "inherit",
    fontVariantEastAsian: "inherit",
    fontWeight: "inherit",
    fontStretch: "inherit",
    lineHeight: "inherit",
    fontFamily: "inherit",
  },
  inputWrapper: {
    paddingBottom: "30px",
  },

  dialogWrapper: {
    height: "100%",
    width: "100%",
    textAlign: "left",
    display: "flex",
    alignContent: "center",
    paddingLeft: "25px",
    paddingRight: "25px",
  },

  buttonRoot: {
    height: "40px",
  },
  buttonText: {
    fontWeight: "bold",
    fontSize: " 0.6875rem",
  },
  addButton: {
    backgroundColor: "#D0D5DD",
  },
  remove: {
    color: "#FF5E69",
    border: "1px solid #A21F28",
    marginRight: theme.spacing(1),
  },
  actions: {
    paddingLeft: "0",
    paddingRight: "0",
    [theme.breakpoints.down("sm")]: {
      height: 70,
    },
  },
  actionBox: {
    marginLeft: "0",
    marginRight: "0",
    [theme.breakpoints.down("sm")]: {
      width: 300,
      margin: 0,
    },
  },
}))

export default styles
